/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _default = function _default(fn, deps, equalityCheck) {
  var refId = (0, _react.useRef)(Number.MIN_SAFE_INTEGER);
  var depsRef = (0, _react.useRef)(deps);
  var prevDeps = depsRef.current;
  if (!equalityCheck(deps, prevDeps)) {
    refId.current++;
  }
  depsRef.current = deps;
  return (0, _react.useMemo)(fn, [refId.current]);
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/hooks/useMemoWithObject/index.js
// module id = 603
// module chunks = 0